import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinner, faExclamationTriangle, faCopy } from "@fortawesome/pro-solid-svg-icons";
export const CopyReferenceUserStep = ({ isCopyingReferenceUser, copyReferenceUserError, copyReferenceUserStatus, copyUserJobId, rowClassName, }) => {
    const getIcon = () => {
        if (isCopyingReferenceUser) {
            return _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true });
        }
        if (copyReferenceUserError) {
            return _jsx(FontAwesomeIcon, { icon: faExclamationTriangle });
        }
        if (copyReferenceUserStatus) {
            return _jsx(FontAwesomeIcon, { icon: faCheckCircle });
        }
        return _jsx(FontAwesomeIcon, { icon: faCopy });
    };
    const getRightContent = () => {
        if (isCopyingReferenceUser) {
            return _jsx("span", { children: copyReferenceUserStatus || "Copying..." });
        }
        if (copyReferenceUserError) {
            return (_jsxs(_Fragment, { children: [_jsx("span", { children: "Failed" }), copyUserJobId && _jsxs("span", { className: "auto-provisioning__job-id", children: ["Job ID: ", copyUserJobId] })] }));
        }
        if (copyUserJobId) {
            return _jsxs("span", { className: "auto-provisioning__job-id", children: ["Job ID: ", copyUserJobId] });
        }
        if (copyReferenceUserStatus) {
            return _jsx("span", { children: copyReferenceUserStatus });
        }
        return null;
    };
    return (_jsxs("div", { className: `auto-provisioning__workflow-row ${rowClassName}`, children: [_jsxs("div", { className: "auto-provisioning__row-left", children: [getIcon(), _jsx("span", { className: "auto-provisioning__row-label", children: "Copy Reference User Configuration" })] }), _jsx("div", { className: "auto-provisioning__row-right", children: getRightContent() })] }));
};
